import { Translation, Translator } from '@morningtrain/react-translations'
import {
  ExecuteOperationOnPipe,
  ModelWithForm,
  TriggerPipelineOnFormSubmit,
  useValue,
  WhenModelValue
} from '@morningtrain/react-resources'
import Smartview from 'widgets/smartviews/Smartview'
import { Fieldset } from 'layouts/index'
import * as Fields from 'support/fields'
import * as Displays from 'support/displays'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import { Pipeline } from '@morningtrain/react-helpers'
import React from 'react'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import SmartviewContentSection from 'widgets/smartviews/partials/SmartviewContentSection'
import Approve from 'support/actions/generic/Approve'
import Decline from 'support/actions/generic/Decline'
import { MountSmartviewWithModelOnPipe } from '@morningtrain/react-smartviews'
import * as UI from 'ui'

export function VacationRequestSmartview ({ create = false }) {
  const id = useValue('id')
  const dateformat = 'D. MMM Y'

  return (
    <Smartview header={<Translation name='smartviews.vacation_request.title' />}>
      <ModelWithForm resourceName='vacation.vacation_requests' resetOnSuccess={create} id={id} clean>
        <Translator namespace='smartviews.vacation_request'>
          <SmartviewContentSection>
            <SmartviewTextGroup>
              <SmartviewText>
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span><Translation name="employee"/></span>
                    <Displays.Text name="requester.name"/>
                  </div>
                  <div className="flex justify-between">
                    <span><Translation name="type"/></span>
                    <Displays.Enum enum="vacation_request_type" name="type"/>
                  </div>
                  <div className="flex justify-between">
                    <span><Translation name="status"/></span>
                    <Displays.Enum enum="request_status" name="status"/>
                  </div>
                  <div className="flex justify-between">
                    <span><Translation name="created_at"/></span>
                    <Displays.Date name="created_at" dateFormat={dateformat}/>
                  </div>
                  <div className="flex justify-between">
                    <span><Translation name="requested_start_at"/></span>
                    <Displays.Date name="requested_start_at" dateFormat={dateformat}/>
                  </div>
                  <div className="flex justify-between">
                    <span><Translation name="requested_end_at"/></span>
                    <Displays.Date name="requested_end_at" dateFormat={dateformat}/>
                  </div>
                  <WhenModelValue name="responded_at">
                    <div className="flex justify-between">
                      <span><Translation name="responded_by"/></span>
                      <Displays.Text name="responder.name"/>
                    </div>
                    <div className="flex justify-between">
                      <span><Translation name="responded_at"/></span>
                      <Displays.Date name="responded_at" dateFormat={dateformat}/>
                    </div>
                  </WhenModelValue>
                  <WhenModelValue name="note">
                    <div className="flex justify-between">
                      <span><Translation name="note"/></span>
                      <Displays.Text name="note"/>
                    </div>
                  </WhenModelValue>
                </div>
              </SmartviewText>
            </SmartviewTextGroup>

          </SmartviewContentSection>

          <SmartviewContentSection>
            <Fieldset cols={1} innerClassName="mt-4">
              <Fields.Date name="start_at" dateFormat={dateformat} label={<Translation name="approved_start_at"/>}/>
              <Fields.Date name="end_at" dateFormat={dateformat} label={<Translation name="approved_end_at"/>}/>
            </Fieldset>
          </SmartviewContentSection>

        </Translator>
        <SmartviewContentSeparator />
        <UI.ButtonWrap>
          <Approve
            indexOperationName='custom_calendar'
            trigger={(
              <UI.Button color='green'>
                <Translation name='generic.approve' />
              </UI.Button>
            )}
          >
            <MountSmartviewWithModelOnPipe smartview={<VacationRequestSmartview />} />
          </Approve>
          <Decline
            indexOperationName='custom_calendar'
            trigger={(
              <UI.Button color='red'>
                <Translation name='generic.decline' />
              </UI.Button>
            )}
          >
            <MountSmartviewWithModelOnPipe smartview={<VacationRequestSmartview />} />
          </Decline>

          <Pipeline>
            <TriggerPipelineOnFormSubmit />
            <ExecuteOperationOnPipe resourceName='vacation.vacation_requests' operationName='custom_calendar' />
          </Pipeline>
        </UI.ButtonWrap>
      </ModelWithForm>
    </Smartview>
  )
}
